const common = {
	rankList:[
		{value:1,label:"榜一",alias1:"榜首"},
		{value:2,label:"榜二",alias1:"榜二"},
		{value:3,label:"榜三",alias1:"榜三"}
	],
	getRankLabel(val,alias){
		let str = ""
		this.rankList.some(item =>{
			if(item.value == val){
				str = item.label
				if(!!alias){
					str = item[alias]
				}
				return true
			}
		})
		return str
	}
}

const base = {
  kindList:[
  	"爱教基地",
  	"国防基地",
  	"党史基地",
  	"革命纪念设施",
  	"红色旅游教育基地",
  ],
  getKindList(){
    return JSON.parse(JSON.stringify(this.kindList))
  },
	spot:{
		type:{
			'文物':1,
		}
	}
}

const other = {
	
	getCulturalUrl(){
		return "http://test.dringworld.com/"
	},
	getHotelHomeUrl(){
		let url = "https://min.ztidt.com/"
    return encodeURIComponent(url)
	},
  getHotelViewUrl(id){
  	let url = "https://min.ztidt.com/#/pages/hotel/detail?hotelId="+id
    return encodeURIComponent(url)
  },
	getRestaurantHomeUrl(){
		let url = "https://bxqwwechat.lishicloud.com/h5/#/"
    return encodeURIComponent(url)
	},
  getRestaurantViewUrl(id,lon,lat){
  	let url = "https://bxqwwechat.lishicloud.com/h5/#/pages/order/details?id="+id+"&longitude="+lon+"&latitude="+lat
    return encodeURIComponent(url)
  }
}

const promotion = {
	homeBanner:'app-home-banner',
	homeData:'app-home-data',
  homeCustomer:'app-home-customer',
	homeNav:'app-home-nav',
	homePosterAnnual:'app-home-poster-annual',
	customServiceIcon:'app-service-customer-icon',
	course:'app-home-course',
  activityBanner:'app-activity-banner',
  shareIcon:'app-share-icon',
	taskIndexList:'app-task-index-list',
  lineFloatWindow:'app-line-floatwindow',
  lineCustomOrg:'app-line-custom-org',
	myMenus:'app-my-menus'
}

const dataType = {
  '景区':100,
	'景区_景点':101,
	'酒店':110,
	'餐饮':120,
	'线路':160,
	'活动':170,
	'课程_信息':180,
  '专辑视频':370,
  '攻略':230,
	'红色_精神':2000,
	'红色_人物':2010,
	'红色_事件':2020,
  '产品_门票':1100,
	'产品_商品':1110,
	'报告_海报':4000,
	getLabel(val){
		let label = ''
		
		return label
	}
}

const dataState = {
	'None':0,
	'正常':1,
	'仅显示':2
}

const idCardType = {
	'None':0,
	'身份证':1,
	getList:() => {
		return [
			{label:'身份证',value:1}
		]
	},
	getLabel:function(val){
		let temp = this.getList().find(t => t.value == val)
		if(temp){
			return temp.label
		}
		return ''
	}
}

const thirdlink = {
  
}

const course = {
  type:{
    
  },
  group:{
    '研学课程':'研学课程',
    '思政教育':'思政教育'
  }
}

const line = {
	type:{
		'周边线路':'周边线路'
	}
}

const lineAsk = {
	status:{
		'审核中':10,
		'审核通过':20,
		'审核拒绝':30
	}
}

const optionParamsCode = {
	'标签_标签':'cont_tag_tag',
	'标签_种类':'cont_tag_kind'
}

const activity = {
  sponsor:{
    '主办方':1,
    '协办方':2
  },
	askField:{
		'姓名':1,
		'联系方式':2,
		'证件号':4,
		'文本':8,
		'图片':16,
		'视频':32
	}
}

const answer = {
	status:{
		'答题中':10,
		'抢答中':20,
		'答题结束':30
	},
  type:{
    '抢答':1,
    '竞赛':2,
  },
	log:{
		status:{
			'失败':10,
			'成功':20
		},
	},
  subject:{
    type:{
      '单选':10,
      '多选':20
    }
  }
}

const order = {
	status:{
		'支付前待确认':10,
		'待支付':20,
		'支付后待确认':30,
		'已支付':40,
		'已过期':50,
		'已完成':60,
		'退款审核中':70,
		'退款处理中':80,
		'退款已完成':90,
		'已取消':100
	},
	user:{
		status:{
			'未使用':10,
			'已使用':20,
			'已退款':30,
			'已取消':40
		},
		type:{
			'游玩人':1,
			'团队负责人':2,
			'活动负责人':4
		}
	}
}

const appKind = {
	'应用内部':0,
  '后台':1,
  '微信小程序':10,
  '支付宝小程序':20,
  '钉钉小程序':30,
  '钉钉H5':31,
  '浙里办':40,
  'WBEH5':50,
}

const live = {
	syncType:{
		'微信视频号':1
	}
}

const prize = {
  askField:{
    '姓名':1,
    '手机号':2,
    '证件号':4,
    '地址':8,
    '备注':512,
  }
}

const member = {
	pv:{
		actionType:{
			'None':0,
			'浏览':10,
			'分享':20,
			'播放':30
		}
	}
}

const mediaTypeClass = {
	'None':0,
	'Image':10,
	'Audio':20,
	'Video':30
}

const report = {
	poster:{
		fieldCode:{
			"注册时间": "reg_time",
			"打卡景区": "clockin_scenic",
			"活动订单": "activity_order",
			"线路订单": "line_order",
			"地图_打卡景区点亮": "map_clockin_scenic",
			"会员_成就": "member_medal"
		}
	}
}

export default{
	report,
	mediaTypeClass,
	member,
  idCardType,
  prize,
	live,
	appKind,
	order,
	answer,
	activity,
	lineAsk,
	line,
	optionParamsCode,
	course,
	thirdlink,
	dataType,
	promotion,
	base,
	common,
	other,
	dataState
}


// WEBPACK FOOTER //
// ./src/libs/enums.js